import firebase, { firestore, functions, auth } from "firebase";
import * as uuid from 'uuid'
import moment from "moment"

export type ValidatedValue<ValueType> = {
  value: ValueType | null
  isError: boolean
  isBlank: boolean
  errorDesc?: string
}
export type Validator<TypeFrom, TypeTo> = (value: TypeFrom) => ValidatedValue<TypeTo>

moment.locale("ja")
/**
 * 文字列 -> Dateのvalidator
 */
export const String2DateValidator: Validator<string, Date | undefined> = (value: string) => {
  const txt = value.trim()
  if (!txt) { return {
    value: undefined,
    isError: false,
    isBlank: true,
  } }
  const m = moment(txt)
  const t = m.isValid() ? m.toDate() : undefined
  return {
    value: t,
    isError: !t,
    isBlank: false,
    errorDesc: t ? undefined : "有効な書式ではありません",
  }
}

/**
 * 入力必須なテキストのvalidator
 */
export const RequiredStringValidator: Validator<string, string> = (value: string) => {
  const x = value.trim()
  return {
    value: x ? x : null,
    isError: !x,
    isBlank: !x,
    errorDesc: x ? undefined : "入力が必要です",
  }
}

/**
 * 入力任意なテキストのvalidator
 */
export const OptionalStringValidator: Validator<string, string | undefined> = (value: string) => {
  const x = value.trim()
  return {
    value: x ? x : null,
    isError: false,
    isBlank: !x,
  }
}

export const YesNoValidator: Validator<string, boolean> = (value: string) => {
  const x = value.trim()
  return {
    value: x === "Yes",
    isError: false,
    isBlank: false,
  }
}

type DatabaseEntity = {
  id: string
  authorId: string
  createdTime: Date
  updatedTime: Date
}

export type ReverseCategory = {
  Slip: SlipItem
  Task: TaskItem
  Schedule: ScheduleItem
}
export type ItemCategory = keyof ReverseCategory // "Slip" | "Task" | "Schedule"

type StringValue = {
  value: string
  caption?: string
}

type ContactAddress = {
  mail: StringValue[]
  tel: StringValue[]
  url: StringValue[]
}

/**
 * 人
 */
export type Person = {
  name: string
  desc?: string
  contact?: ContactAddress
} & DatabaseEntity

type ProtoItem = {
  category: ItemCategory
  resolved: boolean
  resolvedTime?: Date
  pinned?: boolean
  title: string
  desc?: string
} & DatabaseEntity

/**
 * 付箋
 */
export type SlipItem = ProtoItem & {
  category: "Slip"
}

/**
 * TODOタスク
 */
export type TaskItem = ProtoItem & {
  category: "Task"
  deadlineTime?: Date
  wip: boolean
  // /**
  //  * 依存タスク
  //  */
  // requiredTasks?: string[]
}

/**
 * スケジュール(単発)
 */
export type ScheduleItem = ProtoItem & {
  category: "Schedule"
  startTime: Date
  allDay: boolean
  finishTime?: Date
  durationSeconds?: number
  attendee?: string[]
}

export type Item = SlipItem | TaskItem | ScheduleItem

type ItemList = {
  title: string
  itemIds: string[]
} & DatabaseEntity

type ItemSubset = {
  title: string
  category?: ItemCategory
  tag?: string
} & DatabaseEntity

/**
 * ページ
 */
type PageData = {
  title: string

}
